module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"placeholder":"{0} 입력"}}')
  delete Component.options._Ctor
}
